exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".textInputMargin___YUD_5 {\n  margin-top: 10px !important;\n  text-align: left;\n}\n.donateButton___75QuA {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/donateBox.less"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,oBAAoB;CACrB","file":"donateBox.less","sourcesContent":[".textInputMargin {\n  margin-top: 10px !important;\n  text-align: left;\n}\n.donateButton {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"textInputMargin": "textInputMargin___YUD_5",
	"donateButton": "donateButton___75QuA"
};